// pin icons
export const pinIcon = `<svg class="pin-icon" style="fill:$FILLCOLOR;" viewBox="0 0 28 36"><path d="M14,0C6.27,0,0,5.64,0,12.6c0,11.46,14,23.4,14,23.4,0,0,14-12.04,14-23.4C28,5.64,21.73,0,14,0Zm0,21c-3.87,0-7-3.13-7-7s3.13-7,7-7,7,3.13,7,7-3.13,7-7,7Z" /></svg>`;

export const ringIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9.5" fill="white" stroke="$FILLCOLOR" stroke-width="5" /></svg>`;

export const discIcon = `<svg class="pin-icon" style="fill:$FILLCOLOR;" viewBox="0 0 35.51 35.51"><path d="M17.76,0C7.95,0,0,7.95,0,17.76s7.95,17.76,17.76,17.76,17.76-7.95,17.76-17.76S27.56,0,17.76,0h0Z" /></svg>`;

// maps
export const maps = {
    day1: "earth-day1.jpg",
    day2: "earth-day2.jpg",
    night1: "earth-night1.jpg",
    night2: "earth-night2.jpg",
    night3: "earth-night3.jpg",
    bump: "earth-bump.jpg",
};
